import _ from 'lodash'
import { currenciesDetails } from './currenciesDetails'

export const getAdSpend = (ad_spend: number | string, currency: string) => {
  const { symbol, display, space } =
    currenciesDetails[currency as keyof typeof currenciesDetails]
  const neededSpace = space ? ' ' : ''

  const number = Number(ad_spend) || 0
  const result = _.round(number / 100).toLocaleString()

  if (display === 'right') {
    return `${result}${neededSpace}${symbol}`
  }

  return `${symbol}${neededSpace}${result}`
}

export const getFormattedSales = (
  total_amount: number | string,
  currency: string
) => {
  const { symbol, display, space } =
    currenciesDetails[currency as keyof typeof currenciesDetails]
  const neededSpace = space ? ' ' : ''

  const number = Number(total_amount) || 0
  const result = _.round(number / 100).toLocaleString()

  if (display === 'right') {
    return `${result}${neededSpace}${symbol}`
  }

  return `${symbol}${neededSpace}${result}`
}

export const getCpc = (
  ad_spend: number | string,
  views: number | string,
  currency: string
) => {
  const { symbol, display, space } =
    currenciesDetails[currency as keyof typeof currenciesDetails]
  const neededSpace = space ? ' ' : ''

  const spend = (Number(ad_spend) || 0) / 100
  const uniques = Number(views)

  let result

  if (!spend || !uniques) {
    result = 0
  } else {
    result = (spend / uniques).toFixed(2)
  }

  if (display === 'right') {
    return `${result}${neededSpace}${symbol}`
  }

  return `${symbol}${neededSpace}${result}`
}

export const getRoas = (
  total_amount: number | string,
  ad_spend: number | string
) => {
  const spend = (Number(ad_spend) || 0) / 100
  const orders = (Number(total_amount) || 0) / 100

  if (!spend || !orders) return '0'

  return (orders / spend).toFixed(1)
}
